import React, { useRef } from 'react';
import './App.css';
import Header from './components/common/Header';
import ProductSection from './components/product/ProductSection';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  const resetFunctionRef = useRef(null);

  const handleReset = () => {
    if (resetFunctionRef.current) {
      resetFunctionRef.current();
    }
  };

  const handleResetRequest = (resetFn) => {
    resetFunctionRef.current = resetFn;
  };

  return (
    <LanguageProvider>
      <div className="App flex flex-col h-screen w-screen bg-black overflow-hidden">
        <Header onReset={handleReset} />
        <ProductSection onResetRequest={handleResetRequest} />
      </div>
    </LanguageProvider>
  );
}

export default App;
